import { render, staticRenderFns } from "./DriversForm.vue?vue&type=template&id=554fc6e0&"
import script from "./DriversForm.vue?vue&type=script&lang=js&"
export * from "./DriversForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports